import axios from 'axios';

export default {
  state: {
    categories: [],
    loading: false,
    error: null,
    loaded: false // Добавляем флаг, который указывает, были ли загружены данные
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories.data;
      state.loaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    async fetchCategories({ commit, state }) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.categories.length > 0) {
        return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/section/');
        commit('SET_CATEGORIES', response.data);
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching categories:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    allCategories: state => state.categories,
    categoriesLoading: state => state.loading,
    categoriesError: state => state.error,
    categoriesLoaded: state => state.loaded // Добавляем новый геттер
  }
}